import { Button } from 'antd';
import { FilterOutlined, MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { useUnit } from 'effector-react';
import style from './ABStyles.module.css';
import { flyTo } from '../../utils/mapbox-utils.js';
import useWindowSize from '../../hooks/useWindowSize.js';
import { changeFilterModalEv } from '../../models/ABMarketsModel/index.js';

function AbMapControls() {
  const [width, height] = useWindowSize();
  const changeFilterModal = useUnit(changeFilterModalEv);

  const zoomIn = () => {
    flyTo(window.map.getCenter(), window.map.getZoom() + 1);
  };

  const zoomOut = () => {
    flyTo(window.map.getCenter(), window.map.getZoom() - 1);
  };

  return (
    <div className={style.ab_controls_wrapper}>
      <Button
        shape="circle"
        icon={<PlusOutlined style={{ fontSize: 24 }} />}
        className={style.ab_controls_button}
        onClick={zoomIn}
      />
      <Button
        shape="circle"
        icon={<MinusOutlined style={{ fontSize: 24 }} />}
        className={style.ab_controls_button}
        onClick={zoomOut}
      />
      {width < 500 ? (
        <Button
          shape="circle"
          icon={<FilterOutlined style={{ fontSize: 24 }} />}
          className={style.ab_controls_button}
          onClick={() => changeFilterModal(true)}
        />
      ) : null}
    </div>
  );
}

export default AbMapControls;
